import FastIcon from "@components/vpnpricecomparison/svg/fastIcon";
import HideIcon from "@components/vpnpricecomparison/svg/hideIcon";
import MapPinIcon from "@components/vpnpricecomparison/svg/mapPinIcon";
import PerformanceIcon from "@components/vpnpricecomparison/svg/performanceIcon";
import RiskIcon from "@components/vpnpricecomparison/svg/riskIcon";

export const vpnFeatures = [
    {
        title: "Hide Your IP & Protect Your Privacy",
        icon: HideIcon(),
    },
    {
        title: "Access GEO-Blocked Websites & Apps",
        icon: MapPinIcon(),
    },
    {
        title: "Fast Streaming For Netflix, Hulu, & More",
        icon: FastIcon(),
    },
    {
        title: "Fastest VPNs For Browsing, Gaming and Torrents",
        icon: PerformanceIcon(),
    },
    {
        title: "Totally Risk Free VPN Companies",
        icon: RiskIcon(),
    },
];
